import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { NavbarSidebarComponent } from './navbar-sidebar.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxAccordionModule, DxHtmlEditorModule, DxTagBoxModule, DxTextAreaModule, DxPopupModule,DxCheckBoxModule, DxDropDownBoxModule, DxToolbarModule, DxButtonModule, DxActionSheetModule,DxListModule, DxPopoverModule, DxTemplateModule, DxAutocompleteModule, DxTextBoxModule, DxTooltipModule, DxScrollViewModule, DxSelectBoxModule, DxDataGridModule, DxMenuModule, DxGalleryModule, DxTileViewModule, DxResponsiveBoxModule, DxBoxModule} from "devextreme-angular";

import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { CreateUpdateTaskModule } from '../create-update-task/create-update-task.module';
import { NewEmpleoyeActivitiesModule } from 'src/app/pages/sales-management/employee-activities/forms/new-empleoye-activities/new-empleoye-activities.module';
import { NewCustomerModule } from 'src/app/pages/sales-management/employee-activities/forms/new-customer/new-customer.module';
import { CreateUpdateSalesProjectModule } from 'src/app/pages/sales-management/sales-project/create-update-sales-project/create-update-sales-project.module';
import { NewContactModule } from '../new-contact/new-contact.module';
import { ServicesMapModule } from 'src/app/pages/service-management/services-map/map-service/services-map.module';
import { NewServiceWorkOrderModule } from 'src/app/pages/service-management/services-map/components/new-service-work-order/new-service-work-order.module';
import { NewRfiModule } from 'src/app/pages/project-management/edit-project/new-rfi/new-rfi.module';
import { NewPushListItemModule } from 'src/app/pages/project-management/edit-project/new-push-list-item/new-push-list-item.module';
import { NewProgressReportModule } from 'src/app/pages/project-management/edit-project/new-progress-report/new-progress-report.module';
import { AlarmWorkFlowSummaryModule } from 'src/app/pages/project-management/alarm-work-flow-summary/alarm-work-flow-summary.module';
import { AlarmCustomersModule } from 'src/app/pages/sales-management/alarm-customers/alarm-customers.module';
import { LoginModule } from 'src/app/pages/login/login.module';

@NgModule({
  declarations: [
    NavbarSidebarComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxCheckBoxModule,
    DxDropDownBoxModule,
    DxToolbarModule,
    DxButtonModule,
    DxActionSheetModule,
    DxListModule,
    DxPopoverModule,
    DxTemplateModule,
    DxAutocompleteModule,
    GooglePlaceModule,
    DxTextBoxModule,
    DxPopupModule,
    DxTooltipModule,
    CreateUpdateTaskModule,
    NewEmpleoyeActivitiesModule,
    NewCustomerModule,
    DxScrollViewModule,
    CreateUpdateSalesProjectModule,
    NewContactModule,
    NewServiceWorkOrderModule,
    NewRfiModule,
    NewPushListItemModule,
    NewProgressReportModule,
    DxSelectBoxModule,
    DxDataGridModule,
    AlarmWorkFlowSummaryModule,
    AlarmCustomersModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxHtmlEditorModule,
    DxAccordionModule,


    DxMenuModule,
    DxGalleryModule,
    DxTileViewModule,
    DxResponsiveBoxModule,
    DxBoxModule,
    DxTileViewModule,
    LoginModule

    // NewRFIModule
  ],
  exports: [NavbarSidebarComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class NavbarSidebarModule { }
